import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { verifyDocument } from '@app/_models/verifyDocument';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { LogService } from '@app/_shared/log.service';
import { first } from 'rxjs/operators';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { UpdatePaymentReq } from '@app/_models/updatePaymentReq';
import { environment } from '@environments/environment';


const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM/YYYY',
  },
  display: {
    dateInput: 'MMMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-employer-verify-document',
  templateUrl: './employer-verify-document.component.html',
  styleUrls: ['./employer-verify-document.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EmployerVerifyDocumentComponent implements OnInit {
  date = new FormControl(moment());

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);

  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, i) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    var r = this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());
    // var v = moment(this.form.value.StudentDocVerificationRequest[0].yearAndMonth.month() + 1, 'MM').format('MMMM');
    const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);


    myForm.patchValue({
      yearAndMonth: this.date.value,
      yearAndMonthSelect: this.date.value,
      monthOfPassing: moment(this.date.value.month() + 1, 'MM').format('MMMM'),
      yearofpassid: r.id,
    });

  }
  dateFilter = (d: any): boolean => {
    const day = d.year();
    var val = [];
    this.YearOfPassDropDown.forEach((keys: any, vals: any) => {
      var x = keys.yearOfPassing;
      var y: number = +x;
      day !== y + "";
      val.push(y);
    })
    var alphaNumeric = val.join("  && day !== ");;
    var aq = (day !== + alphaNumeric);
    var stringValueYouWant = val.join();

    return stringValueYouWant.indexOf(d.year()) !== -1;
    //return aq;
  }

  fileSizeErr = false;
  verifyDocument = new verifyDocument();
  streams: string[];
  returnUrl;
  showErr = false;
  streamDropDown = [];
  collegeDropDown = [];
  YearOfPassDropDown = [];
  documentDropDown = [];
  RequestTypeDropDown = [];
  firsReqTypeIdForVerification;
  submitted = false;
  filePath;
  strMessage: string;
  EmbassyshowErr = false;
  finalArray = [];
  form: FormGroup;
  embassyidDisabled: boolean = true;
  email = localStorage.getItem('userName');
  name = localStorage.getItem('firstname') + '' + localStorage.getItem('lastname');
  phoneNo = localStorage.getItem('phoneNo');
  amount;
  paymentId
  getStreamId: number;
  EmbassyDropDown = [];
  branchDropDown = [];
  semesterDropDown = [];
  ifZeroAmount = false;
  noYrPriceMast;
  saveIds: any = 0;

  updatePaymentReq  = new UpdatePaymentReq();


  @ViewChild('closebuttonRemark') closebuttonRemark;
  @ViewChild('showModalBoxAlert', { read: TemplateRef }) showModalBoxAlertTemplate: TemplateRef<any>;
  options = {
    // Enter the Key ID generated from the Dashboard - set per-environment in
    // environment.ts (test) / environment.prod.ts (live), not hardcoded here.
    "key": environment.razorpayKey,
    "amount": 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    "currency": "INR",
    "name": "University",
    "description": "Verification Transaction",
    //"image": "assets/images/logo.png",
    // "order_id": "", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    // "callback_url": "http://103.143.39.76:8080/University/login?returnUrl=%2F",
    // "callback_url": 'https://www.google.com',
    "handler": (response) => {

      // alert('payment successfully done, verification request has been created. Please click on home tab');
      // this.IsmodelShow = true;

//change for save first then payment 
      this.updatePaymentReq.paymentid=response.razorpay_payment_id;

      console.log("after payment---", this.updatePaymentReq)

       this.updatePaymentReq.paymentid= response.razorpay_payment_id;
        console.log("after payment",this.updatePaymentReq);
///

    //  this.form.value.StudentDocVerificationRequest.forEach((item, i) => {
      //  this.form.value.StudentDocVerificationRequest[i].paymentId = response.razorpay_payment_id;
       // // this.form.value.StudentDocVerificationRequest[i].requesttype=1;
     //   this.form.value.StudentDocVerificationRequest[i].createby = localStorage.getItem('user_id');
    //  });

    //  this.paymentId = response.razorpay_payment_id;

      //this.verifyDocService.saveStudentVerificationDoc(this.form.value.StudentDocVerificationRequest)
      this.verifyDocService.updateStudentVerificationPaymentFlag(this.updatePaymentReq)
        .pipe(first())
        .subscribe(
          data => {
            console.log("response---", data)
            if (data.respMessage == "Success") {
             // this.amount = data.respData.total_with_gst;

              this.modalService.open(this.showModalBoxTemplate);
              this.closebuttonRemark.nativeElement.click();
              //this.callDispute(0);
             // console.log("amount2", this.amount * 100)
              // alert("Verification Doc has been saved. Total Amount With GST: "+ data.respData.total_with_gst);
              //this.eventService.emit<string>("0")
            }
          },
          error => {
            console.log(error)
          }
        )//,this.closebuttonRemark.nativeElement.click();
    },
    "modal": {
      "ondismiss": function () {
        // alert('close');  
        // this.modalService.open(this.showModalBoxTemplate);
      }
    },
    "prefill": {
      "name": "Rupali Jadhav",
      "email": "manisha.lohbande@scubetechserv.com",
      "contact": "9168781259"
    },
    "notes": {
      "address": "Razorpay Corporate Office"
    },
    "theme": {
      "color": "#3399cc"
    }
  };

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  constructor(private modalService: NgbModal, config: NgbModalConfig, private fb: FormBuilder, private verifyDocService: VerifyDocumentService,
    private eventService: LogService, private router: Router) { }
  productForm: FormGroup;
  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }
  ngOnInit(): void {
    /* Initiate the form structure */

    this.form = this.fb.group({
      StudentDocVerificationRequest: this.fb.array([
        this.initTimes()
      ])
    });
    this.fa.valueChanges.subscribe(value => {
      console.log('name has changed:', value)
    });

    // const val = this.fb.group({
    //   streamid: ['', Validators.required],
    //   docname: ['', Validators.required],
    //   enrollno:  ['', Validators.required],
    //   yearofpassid: ['', Validators.required],
    //   collegenameid: ['', Validators.required],
    //   uniid: '1',
    //   userid: localStorage.getItem('user_id'),
    //   firstname:  ['', Validators.required],
    //   lastname: ['', Validators.required],
    //   uploaddocpath:  '',
    //   filepath: ['', Validators.required]

    // });

    // const form = this.form.get('StudentDocVerificationRequest') as FormArray
    // form.push(val);

    this.verifyDocService.getStreams()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("streams response---", data.respData)
          this.streamDropDown = data.respData;
        },
        error => {

          console.log(error)


        }
      )

      this.verifyDocService.getEmbassy()
      .pipe(first())
      .subscribe(
        data => {
           console.log("getEmbassy response---", data.respData)
          this.EmbassyDropDown = data.respData;
          console.log("getEmbassy response---", this.EmbassyDropDown)
    //   alert("Check Embassy ----"+data.id);
     //  alert('payment_id: ' + payment_id);
        },
        error => {
          console.log(error)
        }
      )


    this.verifyDocService.getColleges()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.collegeDropDown = data.respData;
        },
        error => {

          console.log(error)


        }
      )

    this.verifyDocService.getDocuments()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("Document response---", data.respData)
          this.documentDropDown = data.respData;
        },
        error => {

          console.log(error)


        }
      )

    this.verifyDocService.getRequestType()
      .pipe(first())
      .subscribe(
        data => {
          this.RequestTypeDropDown = data.respData;
          this.firsReqTypeIdForVerification = this.RequestTypeDropDown.find(x => x.requestType === 'Verification').id;
          console.log("ID-----", this.firsReqTypeIdForVerification);
          //       this.form.value.StudentDocVerificationRequest.forEach((item, i) => {
          //       this.form.value.StudentDocVerificationRequest[i].requesttype = this.firsReqTypeIdForVerification;
          //       console.log("ID-----",this.firsReqTypeIdForVerification);
          // });
          console.log(data.respData)
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getYearOfPassing()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("YearOfPassing response---", data.respData)
          this.YearOfPassDropDown = data.respData;
        },
        error => {

          console.log(error)


        }
      )

    // this.productForm = this.fb.group({
    //   doc_verification: this.fb.array([this.fb.group(
    //           {
    //             // applicationId: '',
    //               streamid:'',
    //               docname:'',
    //               enrollno: '',
    //               yearofpassid: '',
    //               collegenameid:'',
    //               // requestTypeId: '',
    //               uniid: '1',
    //               userid: localStorage.getItem('user_id'),

    //               firstname: '',
    //               lastname: '',
    //               // verReqId: '',
    //               uploaddocpath: ''
    //           }
    //       )])
    // })


  }

  getembassylist(i: any, index){
    let y = i.split(':')[1];
  
      let id = Number(y);
      //  alert(  Number(this.emb));
    this.verifyDocService.getEmbassybyId(id)
    .pipe(first())
    .subscribe(
      data => {
        this.EmbassyDropDown[index] = data.respData;
        const val = data.respData[0].id
        console.log("college response---", val);
        if (val == 1 || val ==3) {


      this.embassyidDisabled = false;
      this.EmbassyshowErr = true;
          console.log("Value of embassyidDisabled:", this.embassyidDisabled);
         //   this.form.controls.embassyname.disable();
               console.log("inpVal when disable = ", val);
              //  const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);
              //  myForm.patchValue({
              //   embassyname:"NA"
              //  });
              console.log("CHeck JJJJ",this.form.value);
            //   const controlToUpdate = this.form.get('embassyname'); // Replace 'yourFormControlName' with the actual name or index of the control you want to update.
            //   console.log("controlToUpdate = ", controlToUpdate);
               // Use patchValue to update the form control's value
           //    controlToUpdate.patchValue('NA');
            } else{

              this.embassyidDisabled = true;
              this.EmbassyshowErr = false;
              console.log("Esle fasle:", this.embassyidDisabled);
          //    this.form.controls.embassyname.disable();
            }
      },
      error => {
        console.log(error)
      }
    )
  }

  initTimes() {
    return this.fb.group({
      // requesttype: "1",
      streamid: this.fb.control('', Validators.required),
      docname: this.fb.control('', Validators.required),
     embassyid: this.fb.control('', Validators.required),
    
      semId: this.fb.control('', Validators.required),
      branchId: this.fb.control('', Validators.required),
      //requesttype: this.fb.control(this.firsReqTypeIdForVerification, Validators.required),
      enrollno: this.fb.control('', Validators.required),
      yearofpassid: this.fb.control('', Validators.required),
      collegenameid: this.fb.control('', Validators.required),
      uniid: "1",
      userid: localStorage.getItem('user_id'),
      firstname: this.fb.control('', Validators.required),
      lastname: this.fb.control('', Validators.required),
      uploaddocpath: this.fb.control('', Validators.required),
      filepath: this.fb.control('', Validators.required),
      trackingId: this.generateUniqueId(),
      paymentId: this.fb.control(''),
      yearAndMonth: this.fb.control(''),
      yearAndMonthSelect: this.fb.control(''),
      monthOfPassing: this.fb.control(''),
      embassyname: this.fb.control('NA',  this.EmbassyshowErr ? null : Validators.required),
      embassyaddress: this.fb.control('NA', this.EmbassyshowErr ? null : Validators.required),
    });
  }

  get fa() { return this.form.get('StudentDocVerificationRequest') as FormArray; }

  generateUniqueId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  addGroup() {

    this.fa.push(this.initTimes());

  }

  removeGroup(index) {

    this.fa.removeAt(index);
  }

  trackByFn(index: any, item: any) {
    return item.trackingId;
  }

  onSubmit() {



    this.form.value.StudentDocVerificationRequest.forEach((item, i) => {
      this.form.value.StudentDocVerificationRequest[i].requesttype = this.firsReqTypeIdForVerification;
      console.log("ID-----", this.firsReqTypeIdForVerification);
    });

    console.log('value: ', this.form.value.StudentDocVerificationRequest);
    console.log('valid: ', this.form.valid);
    this.submitted = true;
    if (this.form.valid == false) {
      console.log("here")
      this.showErr = true;
      return;
    }
    this.finalArray.push(this.form.value);
    console.log(this.finalArray)


    this.verifyDocService.getAmount(this.form.value.StudentDocVerificationRequest)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          if (data.respMessage == "Success") {
            if (data.respData.total_with_gst[0] == 99999) {
              this.noYrPriceMast = data.respData.YearNotDefined.join(",");
              this.ifZeroAmount = true;
              return;
            }
            else {
              this.ifZeroAmount = false;//
              this.amount = data.respData.total_with_gst[0];//data.respData.total_with_gst;
              console.log("amount2", this.amount * 100);
              this.strMessage = "payment successfully done, verification request has been created";
              this.options.prefill.contact = this.phoneNo;
              this.email = this.email.replace(/"|'/g, '');;
              this.options.prefill.name = this.name;
              this.options.prefill.email = this.email;
              this.options.amount = this.amount * 100;
              console.log("razorpayamount", this.options.amount);
              this.modalService.open(this.showModalBoxAlertTemplate);
          //    let rzp1 = new this.verifyDocService.nativeWindow.Razorpay(this.options);
          //   rzp1.open();
            }
          }
        },
        error => {
          console.log(error)
        }
      )



  }

  closeAlert() {

 console.log("closeAlert")

      this.verifyDocService.saveStudentVerificationDoc(this.form.value.StudentDocVerificationRequest)
        .pipe(first())
        .subscribe(
          data => {
            console.log("response---after save ver req", data)
            if (data.respMessage == "Success") {
              console.log("amount---closeAlert", data.respData.total_with_gst)
              this.amount = data.respData.total_with_gst;
              this.saveIds = data.respData.saveDocID;
              this.updatePaymentReq.verreqid=data.respData.saveDocID;
              this.updatePaymentReq.verreqidarr=data.respData.saveDocID;
              this.updatePaymentReq.userid=localStorage.getItem('user_id');


              // this.updatePaymentReq.paymentid="9000";
              // console.log("after payment",this.updatePaymentReq);


              // this.verifyDocService.updateStudentVerificationPaymentFlag(this.updatePaymentReq)
              //         .pipe(first())
              //         .subscribe(
              //           data => {
              //             console.log("response---after save ver req", data)
              //             if (data.respMessage == "Success") {
                          
              //             }
              //           },
              //           error => {
              //             console.log(error)
              //           }
              //         )





             // this.modalService.open(this.showModalBoxTemplate);
             //  this.closebuttonRemark.nativeElement.click();
            }
          },
          error => {
            console.log(error)
          }
        )

console.log("after save",this.updatePaymentReq);






    this.modalService.dismissAll(this.showModalBoxAlertTemplate);
    // this.closebuttonAlert.nativeElement.click();
    let rzp1 = new this.verifyDocService.nativeWindow.Razorpay(this.options);
    rzp1.open();
  }


  get docVerification() {
    return this.productForm.get('doc_verification') as FormArray;
  }

  refresh(): void {
    location.reload();
    // this.modalService.dismissAll(this.showModalBoxTemplate);
    // this.eventService.emit<string>("0")
    // this.returnUrl = "employer";
    // this.router.navigate([this.returnUrl]);
  }


  catchEvent(files: FileList, i) {
    console.log(files)
    console.log(i)
    if (files[0].size <= 5242880) {
      this.fileSizeErr = false;
      var formData = new FormData();
      formData.append("file", files.item(0));
      this.verifyDocService.uploadVerificationDocumentFile(formData)
        .pipe(first())
        .subscribe(
          data => {
            console.log("file---upload---response---", data)
            this.filePath = data.respData;
            console.log(this.form.controls.StudentDocVerificationRequest.value[0]['uploaddocpath'])

            this.updateData(i, data.respData);

          },
          error => {
            console.log(error)
          }
        )
    } else {
      const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);

      myForm.patchValue({
        filepath: ""
      });
      this.fileSizeErr = true;
    }
  }

  updateData(index: number, data: String) {
    console.log(index, data)
    const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(index);

    myForm.patchValue({

      filepath: data
    });
    console.log("Before=>", myForm);
    console.log("Before=>", myForm.value);
    console.log(myForm.value.firstname)
  }

  getBranAndStream(i: any, index) {
    let y = i.split(':')[1];
    let id = Number(y);
    //alert(  Number(this.getStreamId));

    this.verifyDocService.getBranch(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.branchDropDown[index] = data.respData;
        },
        error => {
          console.log(error)
        }
      )


    this.verifyDocService.getSemester(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.semesterDropDown[index] = data.respData;
        },
        error => {
          console.log(error)
        }
      )
  }


}
